import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {isUndefined} from 'util';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {AllService} from '../../../services/all.service';
import {Chat, IMessengerConnector, Message} from '../../../types/all.type';
import {combineAll, combineLatest, concatAll, forkJoin, interval, Observable, of, timeout, zip} from 'rxjs';
import {ModalService} from '../../../services/modal.service';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';
import {log} from '../../../functions';
import {delay, map, take} from 'rxjs/operators';
import {NgxModalDraggableDirective} from '../../../directives/draggable.directive';
import {SnotifyPosition, SnotifyService} from 'ng-snotify';
import {InterfaceService} from '../../../services/interface.service';
import {AppService} from '../../../services/app.service';

@Component({
  selector: 'app-modal-forward-message',
  templateUrl: './modal-forward-message.component.html',
  styleUrls: ['./modal-forward-message.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalForwardMessageComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  @Input() messages: Message[] = [];
  @Input() chatId: number | string;
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }

  constructor(
    public appService: AppService,
    public interfaceService: InterfaceService,
    private snotifyService: SnotifyService,
    public allMessengersService: AllMessengersService,
    public modalService: ModalService,
    public bsModalRef: BsModalRef,
    private cd: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService,
    private router: Router,
    public nzModalService: NzModalService,
    public allService: AllService,
  ) {
  }

  ngOnInit(): void {
    this.cd.detectChanges();
    // emit a value every 2 seconds
    /*const source = interval(2000);
    const example = source.pipe(
      //for demonstration, add 10 to and return as observable
      map(val => of(val + 10)),
      //merge values from inner observable
      concatAll()
    );
    //output: 'Example with Basic Observable 10', 'Example with Basic Observable 11'...
    const subscribe = example.pipe(takeUntil(this.destroy$)).subscribe(val =>
      console.log('Example with Basic Observable:', val)
    );*/
  }

  toggleUser(chat: Chat) {
    // Открыть чат по завершению?
    this.snotifyService.clear();
    const count = this.appService.declOfNum(
      this.messages?.length,
      ['# сообщение', '# сообщения', '# сообщений']
    );
    this.snotifyService.clear();
    this.snotifyService.confirm(
      `Вы точно хотите переслать ${count}`,
      this.interfaceService.getChatTitle(chat),
      {
        timeout: 30000,
        titleMaxLength: 30,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Да',
            action: () => {
              this.bsModalRef.hide();
              const chatId = this.chatId ? this.chatId : this.Service.openChatId;
              /// Когда пересылка в другой мессенджер
              if (chat.service_type != this.Service.type) {
                const Service = this.allMessengersService.getService(chat.service_type);
                // TODO реализовать таймаут когда много сообщений
                let i = -1;

                forkJoin(new Observable((observer) => {
                  if (this.messages?.length > 1) {
                    this.notifierWrapService.notify('success', 'Идет пересылка сообщений.');
                  }
                  this.messages.forEach((message: Message, indexMessage) => {
                    i++;
                    setTimeout(() => {
                      let text = `Переслано`;
                      if (message?.name?.first) {
                        text += ` от ${message?.name?.first} ${message?.name?.last}`;
                      }else if (message?.from_user?.username) {
                        text += ` от @${message?.from_user.username}`;
                      }
                      text += ` из ${this.Service.name}:\n\n`;
                      text += `>>> ${message.text || message.text_list}`;
                      i++;
                      Service.sendMessage({
                        chat_id: chat.id,
                        // TODO Доработвть пересылку и медиа
                        text
                      }).subscribe((res) => {
                        delete this.messages[indexMessage];
                        this.cd.detectChanges();
                        observer.next(res);
                      }, error => {
                        observer.error(error);
                        observer.complete();
                      });
                    }, i * 500);
                  });
                }).pipe(take(this.messages?.length))).pipe(take(this.messages?.length)).subscribe(
                  (val) => {
                    this.appService.openChat(chat, Service.type, true);
                    // this.bsModalRef.hide();
                  }, error => {
                    this.notifierWrapService.notify('error', 'Пересланы не все сообщения, попробуйте переслать меньше сообщений.');
                    this.appService.openChat(chat, Service.type, true);
                  });
              }else{
                this.Service.forwardMessages(chat.id, chatId, this.messages).subscribe(
                  (result: any) => {

                  },
                  (error) => {
                    this.interfaceService.errorHandling(error);
                  }
                );
                if (chat.id != chatId) {
                  this.appService.openChat(chat, this.Service.type, true);
                  // this.router.navigate([`/${this.Service.type}/chat/${chat.id}`]);
                } else {
                  this.allService.reloadChat$.next();
                }
              }
            },
            bold: false
          },
          { text: 'Отменить', action: () => {
              log('Clicked: No');
            } }
        ]
      }
    );

    this.interfaceService.detectChangeForNotify();
  }
}
